module.exports = __webpack_public_path__ + "static/media/logo-haver.1e6519e0.jpg";